import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

interface IExposure {
  controlParameters?: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const Exposure: React.FC<IExposure> = ({
    controlParameters,
    expanded,
    handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel7`)}
      key={'panel7'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel7bh-content`}
        id={`panel7bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.exposure')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {controlParameters && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.control_parameters')}</b> ${controlParameters}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default Exposure;
